/* unplugin-vue-components disabled */import script from "./CompetitionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionListItem.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionListItem.vue?vue&type=style&index=0&id=7d7f42b5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7f42b5"]])

export default __exports__